import { sortByFc } from "../lib";

export const actionTypes = {
    fetchSuccess: 'PLAYERS_FETCH_SUCCESS',
    fetchError: 'PLAYERS_FETCH_ERROR',
}

export const fetchSuccess = (players) => (players.map((player, idx) =>
    ({
        id: idx.toString(),
        firstName: player["FIRSTNAME"],
        lastName: player["LASTNAME"],
        fcRank: player["FCRANK"] ? player["FCRANK"] : "N/A",
        league: player["LEAGUE"],
        team: player["TEAM"],
        shoots: player["SHOT"],
        height: player["HEIGHT"],
        weight: player["WEIGHT"],
        position: player["POSITION"],
        nationality: player["NATIONALITY"]
    })
).sort(sortByFc));

export const fetchError = (error) => ({ type: actionTypes.setRankings, payload: [], error });